import React, { FC, useState } from 'react';
import { OutlineItem, PageNavContextType } from './pageNav.types';

export const PageNavContext = React.createContext<PageNavContextType>({
  createNav: () => {},
  outline: [],
});

type Props = {
  outline: OutlineItem[];
};

export const PageNavProvider: FC<Props> = ({ children, outline }) => {
  const [outlineUpdated, setOutlineUpdated] = useState<OutlineItem[]>([]);

  const createNav = (id: string) => {
    const element = outline.find((elem) => elem.id === id);
    if (!element) return;
    setOutlineUpdated((prevOutline) => {
      const outlineIds = prevOutline.map((elem) => elem.id);
      outlineIds.push(element.id);
      const newOutline = outline.filter((elem) => outlineIds.includes(elem.id));
      return newOutline;
    });
  };

  return (
    <PageNavContext.Provider
      value={{
        createNav,
        outline: outlineUpdated,
      }}
    >
      {children}
    </PageNavContext.Provider>
  );
};
